export default __webpack_public_path__ + "static/media/WAS0333.34I-41671_-24941_0.336944cb.jpg";